import { render } from "./Cv.vue?vue&type=template&id=a2a12c7c"
const script = {}

import exportComponent from "G:\\Repositories\\Eve-ning.github.io.old3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__